import { Injectable } from '@angular/core';
import { EventManager } from '@angular/platform-browser';

import { Observable, Subject } from 'rxjs';

import { WindowRefService } from '../window-ref/window-ref.service';

@Injectable({
  providedIn: 'root'
})
export class ResizeService {
  get onResize$(): Observable<Window> {
    return this.resizeSubject.asObservable();
  }

  private readonly resizeSubject = new Subject<Window>();

  constructor(private readonly eventManager: EventManager, { nativeWindow }: WindowRefService<HTMLElement>) {
    this.eventManager.addEventListener(nativeWindow, 'resize', this.onResize.bind(this));
  }

  private onResize(event: Event): void {
    this.resizeSubject.next(event.target as Window);
  }
}
